import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import SendIcon from "@mui/icons-material/Send";
import newRequest from "../../../../utils/newRequest";
import { useTranslation } from "react-i18next";
import CustomSnakebar from "../../../../utils/CustomSnakebar";
import imageLiveUrl from "../../../../utils/urlConverter/imageLiveUrl";

const UpdateCardsection = ({ isVisible, setVisibility, refreshBrandData }) => {
  // get this session data
  const { t, i18n } = useTranslation();
  const updateBrandData = JSON.parse(
    sessionStorage.getItem("updateCardsectionsection")
  );
  // console.log(updateBrandData)
  const [Title, setTitle] = useState("");
  const [title_ar, setTitle_ar] = useState("");
  const [Caption, setCaption] = useState("");
  const [caption_ar, setCaption_ar] = useState("");
  const [status, setstatus] = useState("");
  const [Description, setDescription] = useState("");
  const [description_ar, setDescription_ar] = useState("");
  const [Buttonstatus, setButtonstatus] = useState("");
  const [Page, setPage] = useState("");
  const [Pagedropdown, setPagedropdown] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  const [selectedImage_ar, setSelectedImage_ar] = useState(null);
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleImageChange = (event) => {
    const imageFile = event.target.files[0];
    const imageUrl = URL.createObjectURL(imageFile);
    setSelectedImage(imageUrl);
  };

  const handleImageChange_ar = (event) => {
    const imageFile = event.target.files[0];
    const imageUrl = URL.createObjectURL(imageFile);
    setSelectedImage_ar(imageUrl);
  };

  const getpagedata = async () => {
    try {
      const response = await newRequest.get("/blogs/pages");
      const nameEnArray = response.data;
      setPagedropdown(nameEnArray);
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    setTitle(updateBrandData?.title || "");
    setTitle_ar(updateBrandData?.title_ar || "");
    setCaption(updateBrandData?.caption || "");
    setCaption_ar(updateBrandData?.caption_ar || "");
    setstatus(updateBrandData?.status || 1);
    setDescription(updateBrandData?.description || "");
    setDescription_ar(updateBrandData?.description_ar || "");
    setButtonstatus(updateBrandData?.button || "");
    setPage(updateBrandData?.url || "");
    setSelectedImage(imageLiveUrl(updateBrandData?.image));
    // setSelectedImage_ar(imageLiveUrl(updateBrandData?.image_ar));

    getpagedata();
  }, []);

  const handleCloseUpdatePopup = () => {
    setVisibility(false);
  };

  const handleUpdateBrand = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("title", Title);
    formData.append("title_ar", title_ar);
    formData.append("caption", Caption);
    formData.append("caption_ar", caption_ar);
    formData.append("description", Description);
    formData.append("description_ar", description_ar);
    // formData.append("button", Buttonstatus);
    formData.append("url", Page);
    formData.append("status", Number(status));

    // Append front image file
    const imageInput = document.querySelector("#imageInput");
    if (imageInput.files && imageInput.files[0]) {
      formData.append("image", imageInput.files[0]);
    }

    try {
      const response = await newRequest.put(
        `/updatecards1/${updateBrandData?.id}`,
        formData
      );

      setMessage(
        response?.data?.message ||
          `${"Card"} ${"has been"} ${t("Updated Successfully")}.`
      );
      // console.log(response.data);
      refreshBrandData();
      handleCloseUpdatePopup();
    } catch (error) {
      setError(error?.response?.data?.error || `${t("Something went wrong")}`);
      // console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };

  return (
    <div>
      {message && (
        <CustomSnakebar
          message={message}
          severity="success"
          onClose={resetSnakeBarMessages}
        />
      )}
      {error && (
        <CustomSnakebar
          message={error}
          severity="error"
          onClose={resetSnakeBarMessages}
        />
      )}
      {isVisible && (
        <div className="popup-overlay z-50">
          <div className="popup-container h-auto sm:w-[45%] w-full">
            <div
              className="popup-form w-full"
              style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
              <form className="w-full">
                <h2
                  className={`text-secondary font-sans font-semibold text-2xl ${
                    i18n.language === "ar" ? "text-end" : "text-start"
                  }`}
                >
                  {t("Edit")} {t("Card")}
                </h2>
                <div className="flex flex-col sm:gap-3 gap-3 mt-5">
                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="title"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Title")}
                    </label>
                    <input
                      type="text"
                      id="title"
                      value={Title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Title")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="titleArabic"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Title Arabic")}
                    </label>
                    <input
                      type="text"
                      id="titleArabic"
                      value={title_ar}
                      onChange={(e) => setTitle_ar(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Title Arabic")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="status"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Set Page")}
                    </label>
                    <select
                      id="status"
                      value={Page}
                      onChange={(e) => setPage(e.target.value)}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      <option value="0">-- {t("Select")} --</option>
                      {Pagedropdown &&
                        Pagedropdown.map((itme, index) => {
                          return (
                            <option key={index} value={itme.slug}>
                              {itme.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="caption"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("English Caption")}
                    </label>
                    <input
                      type="text"
                      id="caption"
                      value={Caption}
                      onChange={(e) => setCaption(e.target.value)}
                      placeholder={`${t("Enter")} ${t("English Caption")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="captionar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Caption Arabic")}
                    </label>
                    <input
                      type="text"
                      id="captionar"
                      value={caption_ar}
                      onChange={(e) => setCaption_ar(e.target.value)}
                      placeholder={`${t("Enter")}${t("Caption Arabic")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="status"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Status")}
                    </label>
                    <select
                      id="status"
                      value={status}
                      onChange={(e) => setstatus(e.target.value)}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      <option value="0">{t("Inactive")}</option>
                      <option value="1">{t("Active")}</option>
                    </select>
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="description"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Description")}
                    </label>
                    <textarea
                      type="text"
                      id="description"
                      value={Description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Description")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="descriptionar"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Description Arabic")}
                    </label>
                    <textarea
                      type="text"
                      id="descriptionar"
                      value={description_ar}
                      onChange={(e) => setDescription_ar(e.target.value)}
                      placeholder={`${t("Enter")}${t("Description Arabic")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div>

                  {/* <div className="w-full font-body sm:text-base text-sm flex flex-col gap-2">
                    <label
                      htmlFor="Button"
                      className={`text-secondary  ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    >
                      {t("Button")}
                    </label>
                    <input
                      type="text"
                      id="Button"
                      value={Buttonstatus}
                      onChange={(e) => setButtonstatus(e.target.value)}
                      placeholder={`${t("Enter")} ${t("Button text")}`}
                      className={`border w-full rounded-sm border-[#8E9CAB] p-2 mb-3 ${
                        i18n.language === "ar" ? "text-end" : "text-start"
                      }`}
                    />
                  </div> */}

                  <div className="flex justify-between flex-col sm:flex-row ">
                    <div className="">
                      <span className="text-secondary font-body sm:text-base text-sm">
                        {t("Image")}
                      </span>
                      <div className="border-2 border-dashed h-56 w-56 relative flex justify-center">
                        <div className="absolute -bottom-4 flex justify-center items-center h-10 w-3/4 bg-secondary text-white font-body">
                          <label
                            htmlFor="imageInput"
                            className="cursor-pointer whitespace-nowrap"
                          >
                            {t("Select Image")}
                            <input
                              type="file"
                              id="imageInput"
                              // accept="image/*"
                              onChange={handleImageChange}
                              style={{ display: "none" }}
                            />
                          </label>
                        </div>
                        {selectedImage && (
                          <div className="h-56 flex justify-center items-center object-contain w-auto">
                            <img
                              src={selectedImage}
                              className="h-56 w-56"
                              alt="Selected Image"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full flex justify-center items-center gap-8 mt-5">
                  <button
                    type="button"
                    className="px-5 py-2 w-[30%] rounded-sm bg-primary text-white font-body text-sm"
                    onClick={handleCloseUpdatePopup}
                  >
                    {t("Close")}
                  </button>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#021F69", color: "#ffffff" }}
                    onClick={handleUpdateBrand}
                    disabled={loading}
                    className="w-[70%] ml-2"
                    endIcon={
                      loading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        <SendIcon />
                      )
                    }
                  >
                    {t("Update")} {t("Card")}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateCardsection;
